// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__4YniC","bigColWidth":"Table_bigColWidth__t_BE2","biggerColWidth":"Table_biggerColWidth__2rDz9","row":"Table_row__2vE6z","col":"Table_col__3Ajl7"};